document.addEventListener( 'DOMContentLoaded', () => {
	
	// 1. GESTION DU MENU MOBILE (Burger principal)
	const navWrappers = document.querySelectorAll( '.my-custom-nav-wrapper' );
	navWrappers.forEach( ( wrapper ) => {
		const toggleBtn = wrapper.querySelector( '.my-custom-nav-toggle' );
		if ( toggleBtn ) {
			toggleBtn.addEventListener( 'click', () => {
				const isExpanded = toggleBtn.getAttribute( 'aria-expanded' ) === 'true';
				toggleBtn.setAttribute( 'aria-expanded', ! isExpanded );
				wrapper.classList.toggle( 'is-menu-open' );
			} );
		}
	});

	// 2. GESTION DES MEGA MENUS SUR MOBILE (Accordéon)
	const megaMenuToggles = document.querySelectorAll('.mega-menu-toggle');
	megaMenuToggles.forEach(toggle => {
		toggle.addEventListener('click', (e) => {
			if (window.innerWidth <= 768) {
				e.preventDefault(); 
				
				const parentItem = toggle.closest('.my-custom-mega-menu-item');
				const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

				toggle.setAttribute('aria-expanded', !isExpanded);
				parentItem.classList.toggle('is-mega-menu-open');
			}
		});
	});

	// 3. CENTRAGE DU MEGA MENU SUR L'ÉCRAN (Desktop)
	const centerMegaMenus = () => {
		if (window.innerWidth <= 768) return; 
		
		const megaMenus = document.querySelectorAll('.my-custom-mega-menu-item');
		megaMenus.forEach(item => {
			const dropdown = item.querySelector('.mega-menu-dropdown-content');
			if(dropdown) {
				dropdown.style.left = '0px'; 
				const itemRect = item.getBoundingClientRect();
				const dropdownWidth = dropdown.offsetWidth;
				const screenCenter = window.innerWidth / 2;
				const offset = screenCenter - (dropdownWidth / 2) - itemRect.left;
				dropdown.style.left = `${offset}px`;
			}
		});
	};

	window.addEventListener('load', centerMegaMenus);
	window.addEventListener('resize', centerMegaMenus);
	centerMegaMenus();

	// --- 4. GESTION DU LIEN ACTIF (Méthode infaillible avec l'API URL) ---
	const highlightCurrentPage = () => {
		try {
			// 1. On crée un objet URL intelligent à partir de la page courante
			const currentUrl = new URL(window.location.href);
			
			// On extrait uniquement le chemin (ex: "/gwenn") en nettoyant le slash final
			let currentPath = currentUrl.pathname.replace(/\/$/, '');
			if (currentPath === '') currentPath = '/'; // Sécurité pour la racine absolue

			const navLinks = document.querySelectorAll('.my-custom-nav-list a');

			navLinks.forEach(link => {
				if (!link.href) return;
				
				try {
					// 2. On fait pareil pour chaque lien du menu
					// (Le 2ème paramètre permet de gérer les liens relatifs)
					const linkUrl = new URL(link.href, window.location.origin);
					
					let linkPath = linkUrl.pathname.replace(/\/$/, '');
					if (linkPath === '') linkPath = '/';

					// 3. Comparaison chirurgicale : on vérifie le domaine ET le chemin
					// (Cela ignore totalement les ?truc=machin et les #ancres)
					if (currentUrl.hostname === linkUrl.hostname && currentPath === linkPath) {
						
						link.classList.add('is-active-link');

						const parentMegaMenu = link.closest('.my-custom-mega-menu-item');
						if (parentMegaMenu) {
							parentMegaMenu.classList.add('is-active-ancestor');
						}
					}
				} catch (e) {
					// Ignore silencieusement les liens mal formés (ex: href="javascript:void(0)")
				}
			});
		} catch (error) {
			console.warn("Erreur d'analyse URL pour le menu actif :", error);
		}
	};
	highlightCurrentPage();

} );